exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificationBell .notification .notification-icon{text-align:center;width:100%;height:100%}.notificationBell .counter-wrapper,.notificationBell .counter-wrapper .odometer-inside{display:grid;grid-auto-flow:column}", ""]);

// exports
